<template>
  <v-container grid-list-md class="fix-container  pl-0 pr-0 pt-0 card-pb">
    <v-layout>
      <v-flex xs12 class="pa-0">
        <v-layout row wrap justify-space-between style="flex: 1" v-if="!showDashboardRank">
          <!-- <v-flex class="pa-2 white common-card blue-text-normal" style="flex:1">
            <test-report/>
          </v-flex> -->
          <v-flex class="white  card-ml" style="flex: 1">
            <broad :showDashboardRank="showDashboardRank" :personShow="true" />
          </v-flex>
        </v-layout>

        <v-layout row wrap flex-direction-column v-else>

          <v-flex class="pa-2 white common-card blue-text-normal card-pb personal-count" style="padding-bottom:35px!important" >
            <!-- <person-info/>
            <div class="mt-3 mb-4" style="height: 1px; border-top: 1px solid #E0E0E0;"></div>
            <teaching-dynamics/> -->
            <ranks />
          </v-flex>
          <v-flex class="pa-2 white common-card blue-text-normal personal-count" >
            <broad :showDashboardRank="showDashboardRank" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
// import trailClass from './trailClass/'
import ranks from '../perosonTop/ranks/index.vue'
import broad from '../broad/index.vue'
import testReport from './testReport/'
import personInfo from '../perosonTop/personInfo/index.vue'
import teachingDynamics from '../Report/trailClass'

export default {
  props: ['showDashboardRank'],
  name: 'report',
  data: () => ({
    imgPath: 'myReferrals'
  }),
  components: {
    ranks,
    broad,
    testReport,
    personInfo,
    teachingDynamics
  }
}
</script>
<style lang="sass" scoped>
  @import './report'
</style>
